import axios from "axios";
import { _throw } from "../utils/error-service";
import { API } from '../constants/system';

/**
 * Fetches all integrations for a given merchant.
 * @param {string|number} merchantId - The ID of the merchant.
 * @param {string} token - The authorization token.
 * @returns {Promise<object>} The API response.
 */
export const api_get_integrations = async (merchantId, token) => {
  if (!merchantId) {
    console.error('api_get_integrations: merchantId is required');
    return _throw({ response: { data: { message: 'Merchant ID is required' } } });
  }
  try {
    const res = await axios.get(`${API}/cms/integrations/${merchantId}`, {
      headers: {
        'Authorization': token
      }
    });
    return res;
  } catch (err) {
    console.error(`Error fetching integrations for merchant ${merchantId}:`, err);
    return _throw(err);
  }
};

/**
 * Activates or updates an integration for a given merchant.
 * @param {string|number} merchantId - The ID of the merchant.
 * @param {object} integrationData - The data for the integration (apiKey, dispensaryName, integrationId).
 * @param {string} token - The authorization token.
 * @returns {Promise<object>} The API response.
 */
export const api_activate_integration = async (merchantId, integrationData, token) => {
  if (!merchantId) {
    console.error('api_activate_integration: merchantId is required');
    return _throw({ response: { data: { message: 'Merchant ID is required' } } });
  }
  if (!integrationData || !integrationData.integrationId) {
    console.error('api_activate_integration: integrationId is required in integrationData');
    return _throw({ response: { data: { message: 'Integration ID is required' } } });
  }

  const { apiKey, dispensaryName, integrationId, clientId, syncOrders } = integrationData;

  try {
    const res = await axios.post(`${API}/cms/activate-integration/${merchantId}`, 
      { apiKey, dispensaryName, integrationId, clientId, syncOrders }, // request body
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );
    return res;
  } catch (err) {
    console.error(`Error activating/updating integration ${integrationId} for merchant ${merchantId}:`, err);
    return _throw(err);
  }
};
